import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Back from "../components/button/back";

const EditEkskul = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [ekskul, setEkskul] = useState({
    Judul: "",
    Deskripsi: "",
    Jadwal: "",
    Gambar: null,
  });
  const [file, setFile] = useState(null);
  const [previewURL, setPreviewURL] = useState(null);

  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchEkskul = async () => {
      try {
        const response = await axios.get(`${BASE_URL}api/ekskul/${id}`);
        setEkskul(response.data);
        if (response.data.Gambar?.filename) {
          setPreviewURL(
            `${BASE_URL}api/ekskul/media/${response.data.Gambar.filename}`
          );
        }
      } catch (error) {
        console.error("Error fetching ekskul:", error);
      }
    };

    fetchEkskul();
  }, [id, BASE_URL]);

  const handleChange = (e) => {
    setEkskul({ ...ekskul, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    if (selectedFile) {
      setPreviewURL(URL.createObjectURL(selectedFile));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("Judul", ekskul.Judul);
    formData.append("Deskripsi", ekskul.Deskripsi);
    formData.append("Jadwal", ekskul.Jadwal || "");

    if (file) {
      formData.append("file", file); // key harus sama dengan middleware `upload.single("file")`
    }

    try {
      await axios.put(`${BASE_URL}api/ekskul/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      navigate("/admin/ekstrakulikuler");
    } catch (error) {
      console.error("Error updating ekskul:", error);
    }
  };

  return (
    <div className="container mx-auto mt-10">
      <h2 className="text-2xl font-bold mb-5">Edit Ekskul</h2>
      <form onSubmit={handleSubmit} className="space-y-5">
        {/* Judul */}
        <div>
          <label className="block font-medium">Judul</label>
          <input
            type="text"
            name="Judul"
            value={ekskul.Judul}
            onChange={handleChange}
            className="border w-full px-3 py-2 rounded"
            required
          />
        </div>

        {/* Gambar/Video */}
        <div>
          <label className="block font-medium">Gambar / Video</label>
          <input
            type="file"
            name="file"
            accept="image/*,video/*"
            onChange={handleFileChange}
            className="border w-full px-3 py-2 rounded"
          />
          {previewURL && (
            <div className="mt-3">
              {file?.type?.startsWith("video/") ||
              ekskul?.Gambar?.mimetype?.startsWith("video/") ? (
                <video
                  src={previewURL}
                  controls
                  className="w-48 h-32 rounded shadow"
                />
              ) : (
                <img
                  src={previewURL}
                  alt="Preview"
                  className="w-32 h-32 rounded shadow object-cover"
                />
              )}
            </div>
          )}
        </div>

        {/* Deskripsi */}
        <div>
          <label className="block font-medium">Deskripsi</label>
          <textarea
            name="Deskripsi"
            value={ekskul.Deskripsi}
            onChange={handleChange}
            rows="4"
            className="border w-full px-3 py-2 rounded"
            required
          ></textarea>
        </div>

        {/* Jadwal (opsional jika ada) */}
        <div>
          <label className="block font-medium">Jadwal (opsional)</label>
          <input
            type="text"
            name="Jadwal"
            value={ekskul.Jadwal || ""}
            onChange={handleChange}
            className="border w-full px-3 py-2 rounded"
          />
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Update
        </button>
      </form>

      <div className="flex justify-center mt-6">
        <Link to="/admin/ekstrakulikuler">
          <Back />
        </Link>
      </div>
    </div>
  );
};

export default EditEkskul;
